export const CONTENT = {
  phone: "+91 97033 51629",
  address: "Gopanapally, Hyderabad, Telangana, India",
  heroLine1Plain: "Engineering Strong",
  heroLine1Accent: " Structures.",
  heroLine2Plain: "Building",
  heroLine2Accent: " Better Spaces.",
  heroSubtext:
    "Renuka Roofing Structurals provides professional structural fabrication, roofing solutions, structural design and prefabricated construction solutions for residential, commercial and industrial requirements in Hyderabad and surrounding areas.",
  aboutP1:
    "Renuka Roofing Structurals is a Hyderabad-based structural fabrication and construction solutions company specializing in steel structures, roofing systems, structural design and prefabricated houses.",
  aboutP2:
    "We focus on delivering practical, durable and cost-effective structural solutions for residential, commercial and industrial projects.",
  aboutP3:
    "Our approach combines engineering, quality fabrication and efficient execution to help customers turn their construction requirements into strong and functional spaces.",
  mission:
    "To deliver reliable, durable and professionally engineered structural and prefabricated construction solutions while maintaining high standards of quality, safety and customer satisfaction.",
  vision:
    "To become a trusted name in structural fabrication and prefabricated construction solutions across Hyderabad and Telangana.",
  ctaHeading: "Planning a New Structure or Prefabricated House?",
  ctaText: "Talk to Renuka Roofing Structurals about your project requirements.",
};

export const telHref = () => `tel:+${CONTENT.phone.replace(/\D/g, "")}`;

export const whatsappHref = () =>
  `https://wa.me/${CONTENT.phone.replace(/\D/g, "")}?text=Hello%20Renuka%20Roofing%20Structurals%2C%20I%20would%20like%20to%20discuss%20a%20project.`;

export const CONTENT_FIELDS = [
  { key: "heroLine1Plain", label: "Hero — Headline Line 1" },
  { key: "heroLine1Accent", label: "Hero — Headline Line 1 (blue part)" },
  { key: "heroLine2Plain", label: "Hero — Headline Line 2" },
  { key: "heroLine2Accent", label: "Hero — Headline Line 2 (blue part)" },
  { key: "heroSubtext", label: "Hero — Supporting Text", multiline: true },
  { key: "aboutP1", label: "About — Paragraph 1", multiline: true },
  { key: "aboutP2", label: "About — Paragraph 2", multiline: true },
  { key: "aboutP3", label: "About — Paragraph 3", multiline: true },
  { key: "mission", label: "Our Mission", multiline: true },
  { key: "vision", label: "Our Vision", multiline: true },
  { key: "ctaHeading", label: "CTA Banner — Heading" },
  { key: "ctaText", label: "CTA Banner — Text" },
  { key: "phone", label: "Phone Number (drives Call & WhatsApp buttons)" },
  { key: "address", label: "Address" },
];

export const NAV_LINKS = [
  { label: "Home", href: "#home" },
  { label: "About Us", href: "#about" },
  { label: "Services", href: "#services" },
  { label: "Structural Design", href: "#structural-design" },
  { label: "Prefabricated Houses", href: "#prefab" },
  { label: "Projects", href: "#projects" },
  { label: "Gallery", href: "#gallery" },
  { label: "Why Choose Us", href: "#why-us" },
  { label: "Contact", href: "#contact" },
];

export const IMAGES = {
  hero: "https://images.unsplash.com/uploads/14123892966835548e7bd/14369636?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTN8MHwxfHNlYXJjaHwxfHxzdGVlbCUyMGZyYW1lJTIwY29uc3RydWN0aW9ufGVufDB8fHx8MTc4ODY4NjM5NHww&ixlib=rb-4.1.0&q=85",
  about:
    "https://images.pexels.com/photos/2314022/pexels-photo-2314022.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  structuralDesign:
    "https://images.pexels.com/photos/31197870/pexels-photo-31197870.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  prefab1:
    "https://images.unsplash.com/photo-1726471809607-b7f016a1696e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA4Mzl8MHwxfHNlYXJjaHw0fHxtb2Rlcm4lMjBwcmVmYWIlMjBob3VzZSUyMGV4dGVyaW9yfGVufDB8fHx8MTc4ODY4NjM5NHww&ixlib=rb-4.1.0&q=85",
  prefab2:
    "https://images.unsplash.com/photo-1698994705178-d244d73ea573?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA4Mzl8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjBwcmVmYWIlMjBob3VzZSUyMGV4dGVyaW9yfGVufDB8fHx8MTc4ODY4NjM5NHww&ixlib=rb-4.1.0&q=85",
  prefab3:
    "https://images.unsplash.com/photo-1628744448840-55bdb2497bd4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA4Mzl8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBwcmVmYWIlMjBob3VzZSUyMGV4dGVyaW9yfGVufDB8fHx8MTc4ODY4NjM5NHww&ixlib=rb-4.1.0&q=85",
  roofing:
    "https://images.unsplash.com/photo-1504307651254-35680f356dfd?auto=format&fit=crop&w=1200&q=80",
  steel:
    "https://images.unsplash.com/photo-1429497419816-9ca5cfb4571a?auto=format&fit=crop&w=1200&q=80",
  warehouse:
    "https://images.unsplash.com/photo-1553413077-190dd305871c?auto=format&fit=crop&w=1200&q=80",
  commercial:
    "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?auto=format&fit=crop&w=1200&q=80",
  industrial:
    "https://images.unsplash.com/photo-1581094794329-c8112a89af12?auto=format&fit=crop&w=1200&q=80",
};

export const SERVICES = [
  { icon: "Hammer", title: "Structural Steel Fabrication", desc: "Custom steel fabrication for residential, commercial and industrial structures." },
  { icon: "Home", title: "Roofing Structures", desc: "Design and fabrication of durable roofing structures for homes, commercial buildings, warehouses and industrial facilities." },
  { icon: "DraftingCompass", title: "Structural Design", desc: "Professional structural planning and design solutions based on project requirements." },
  { icon: "Building", title: "Prefabricated Houses", desc: "Modern prefabricated homes designed for faster construction, efficient space utilization and cost-effective development." },
  { icon: "Factory", title: "Industrial Structures", desc: "Fabrication and structural solutions for warehouses, workshops, industrial facilities and other commercial requirements." },
  { icon: "Warehouse", title: "Warehouse Structures", desc: "Steel warehouse structures designed for strength, durability and efficient utilization of space." },
  { icon: "Building2", title: "Commercial Structures", desc: "Structural fabrication solutions for offices, shops, commercial buildings and other business requirements." },
  { icon: "PencilRuler", title: "Custom Fabrication", desc: "Customized steel fabrication according to drawings, dimensions, specifications and customer requirements." },
  { icon: "Truck", title: "Installation & Erection", desc: "Professional on-site installation and erection of fabricated structural components." },
];

export const PROJECT_CATEGORIES = [
  "Roofing Structures",
  "Steel Structures",
  "Prefabricated Houses",
  "Warehouses",
  "Commercial Projects",
  "Industrial Structures",
];

export const PROJECTS = [
  {
    id: "p1",
    title: "Industrial Roofing Structure",
    category: "Roofing Structures",
    location: "Hyderabad, Telangana",
    desc: "Design, fabrication and installation of a durable steel roofing structure for an industrial facility.",
    img: IMAGES.roofing,
  },
  {
    id: "p2",
    title: "Structural Steel Framework",
    category: "Steel Structures",
    location: "Gopanapally, Hyderabad",
    desc: "Custom structural steel framework fabricated to project drawings and site requirements.",
    img: IMAGES.steel,
  },
  {
    id: "p3",
    title: "Modern Prefab Residence",
    category: "Prefabricated Houses",
    location: "Hyderabad Outskirts",
    desc: "A modern prefabricated home with an efficient layout and contemporary finish.",
    img: IMAGES.prefab1,
  },
  {
    id: "p4",
    title: "Storage Warehouse Structure",
    category: "Warehouses",
    location: "Telangana",
    desc: "Steel warehouse structure engineered for strength and efficient space utilization.",
    img: IMAGES.warehouse,
  },
  {
    id: "p5",
    title: "Commercial Building Framework",
    category: "Commercial Projects",
    location: "Hyderabad",
    desc: "Structural fabrication for a commercial building, executed from design to erection.",
    img: IMAGES.commercial,
  },
  {
    id: "p6",
    title: "Factory Shed Structure",
    category: "Industrial Structures",
    location: "Hyderabad",
    desc: "Fabrication and erection of a robust factory shed structure for industrial operations.",
    img: IMAGES.industrial,
  },
];

export const PROCESS_STEPS = [
  { title: "Consultation", desc: "Understand the customer's requirements, site and budget." },
  { title: "Planning & Design", desc: "Develop an appropriate structural concept and design." },
  { title: "Estimation", desc: "Prepare a project estimate based on materials, design and scope." },
  { title: "Fabrication", desc: "Fabricate structural components with attention to dimensions and quality." },
  { title: "Transportation & Installation", desc: "Transport and install the fabricated components at the project location." },
  { title: "Project Completion", desc: "Complete the project and hand over the finished structure." },
];

export const DESIGN_FLOW = [
  { icon: "ClipboardList", label: "Requirement" },
  { icon: "PencilRuler", label: "Design" },
  { icon: "Calculator", label: "Engineering" },
  { icon: "Hammer", label: "Fabrication" },
  { icon: "Truck", label: "Installation" },
  { icon: "Flag", label: "Completion" },
];

export const PREFAB_BENEFITS = [
  "Faster construction",
  "Efficient use of materials",
  "Reduced construction time",
  "Flexible designs",
  "Modern appearance",
  "Easy customization",
  "Suitable for residential and commercial applications",
  "Cost-conscious construction solutions",
];

export const PREFAB_CATEGORIES = [
  { title: "Compact Prefab Homes", desc: "Ideal for smaller residential requirements.", img: IMAGES.prefab1 },
  { title: "Modern Prefab Homes", desc: "Contemporary designs with efficient layouts.", img: IMAGES.prefab2 },
  { title: "Custom Prefab Structures", desc: "Designed according to the customer's land, space and requirements.", img: IMAGES.prefab3 },
];

export const WHY_US = [
  { icon: "BadgeCheck", title: "Quality-Focused Fabrication", desc: "Attention to fabrication quality and project requirements." },
  { icon: "Cog", title: "Practical Engineering", desc: "Structural solutions focused on functionality and durability." },
  { icon: "SlidersHorizontal", title: "Customized Solutions", desc: "Projects can be adapted to individual site and customer requirements." },
  { icon: "Workflow", title: "Efficient Execution", desc: "A structured workflow from planning through installation." },
  { icon: "MessagesSquare", title: "Transparent Communication", desc: "Keep customers informed throughout the project." },
  { icon: "Building2", title: "Residential & Industrial Capability", desc: "Solutions for homes, commercial buildings and industrial applications." },
];

export const TRUST_ITEMS = [
  { icon: "DraftingCompass", title: "Structural Expertise", desc: "Engineered solutions designed for strength, durability and reliability." },
  { icon: "Hammer", title: "Quality Fabrication", desc: "Precision fabrication using quality materials and professional workmanship." },
  { icon: "SlidersHorizontal", title: "Custom Solutions", desc: "Structures and buildings designed according to project requirements." },
  { icon: "Workflow", title: "End-to-End Service", desc: "From design and fabrication to installation and completion." },
];

export const GALLERY = [];

export const IMAGE_SLOTS = [
  { key: "hero", label: "Hero Background" },
  { key: "about", label: "About — Workshop Photo" },
  { key: "structuralDesign", label: "Structural Design Section" },
  { key: "prefab1", label: "Prefab — Compact Homes" },
  { key: "prefab2", label: "Prefab — Modern Homes" },
  { key: "prefab3", label: "Prefab — Custom Structures" },
  { key: "roofing", label: "Project — Roofing Structures" },
  { key: "steel", label: "Project — Steel Structures" },
  { key: "warehouse", label: "Project — Warehouses" },
  { key: "commercial", label: "Project — Commercial" },
  { key: "industrial", label: "Project — Industrial" },
];
